import React from 'react';

const SvgArrowDown = props => (
  <svg width={10} height={6} {...props}>
    <path
      d="M9.805 1.195l-4.31 4.31a.7.7 0 0 1-.99 0l-4.31-4.31A.7.7 0 0 1 .69 0h8.62a.7.7 0 0 1 .495 1.195z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgArrowDown;
